import React, { useState } from "react";
import { GoArrowDownRight } from "react-icons/go";

const GallerySection = ({ title, images }) => {
  const [visibleCount, setVisibleCount] = useState(4);

  return (
    <div className={`gallery-box ${title.toLowerCase()} mt-4`}>
      <div className="text d-flex align-items-center justify-content-between">
        <h5 className="mb-0">
          {title} <span style={{ fontSize: "14px", color: "#777" }}>
            ({images.length} Images)
          </span>
        </h5>
      </div>

      <div className="main-gallery-box d-flex flex-wrap gap-2 mt-2">
        {images.slice(0, visibleCount).map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${title} ${index}`}
            className="img-fluid"
            style={{ width: "150px", borderRadius: "8px" }}
          />
        ))}
      </div>

      {visibleCount < images.length && (
        <button
          className="btn btn-primary mt-2"
          onClick={() => setVisibleCount(visibleCount + 4)}
        >
          View More
          <GoArrowDownRight />
        </button>
      )}
    </div>
  );
};

export default GallerySection;
